<template>
  <el-form
    ref="form"
    :model="addData"
    label-width="90px"
    label-position="center"
    id="printTest"
  >
    <el-row>
      <el-col :span="12">
        <el-form-item label="订单编号" prop="orderWorkNo">
          <el-input
            v-model="addData.orderWorkNo"
            placeholder="无"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报事人" prop="userName">
          <el-input
            v-model="addData.userName"
            placeholder="无"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="房屋信息" prop="houseNumber">
          <el-input
            v-model="addData.houseNumber"
            placeholder="无"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报事时间" prop="createTime">
          <el-input
            v-model="addData.createTime"
            placeholder="无"
            disabled
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="报事内容" prop="des">
          <el-input type="textarea" :rows="5" v-model="addData.des" placeholder="无" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="报事图片" prop="createTime">
          <div v-if="addData.img" v-viewer style="cursor: pointer">
            <img
              :src="item"
              v-for="(item, ind) in addData.img.split(',')"
              :key="ind"
              alt=""
              style="width: 100px; height: 100px"
            />
          </div>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="list" v-if="orderInfos.recordList.length > 0">
      <div class="li" v-for="(item, ind) in orderInfos.recordList" :key="ind">
        <template v-if="item.status == 1">
          <el-row>
            <el-col :span="12">
              <el-form-item label="派单时间" prop="createTime">
                <el-input
                  v-model="item.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="派单描述" prop="des">
                <el-input
                  v-model="addData.des"
                  placeholder="无"
                  disabled
                  type="textarea"
                  :rows="5"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="派单流程" prop="content">
                <el-input
                  v-model="item.content"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理时限" prop="subscribeTime">
                <el-input
                  v-model="addData.subscribeTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            
            <!-- <el-col :span="24">
            <el-form-item label="图片" prop="img">
            <div v-if="addData.img" v-viewer style="cursor: pointer">
                <img
                :src="item"
                v-for="(item, ind) in addData.img.split(',')"
                :key="ind"
                alt=""
                style="width: 100px; height: 100px"
                />
            </div>
            </el-form-item>
        </el-col> -->
          </el-row>
        </template>
        <template v-if="item.status == 2">
          <el-row>
            <el-col :span="12">
              <el-form-item label="接收人" prop="userName">
                <el-input
                  v-model="addData.userName"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接收时间" prop="createTime">
                <el-input
                  v-model="item.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="item.status == 3">
          <el-row>
            <el-col :span="12">
              <el-form-item label="完成时间" prop="createTime">
                <el-input
                  v-model="item.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="完成描述" prop="des">
                <el-input
                  v-model="item.des"
                  placeholder="无"
                  type="textarea" 
                  :rows="5"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="完成图片" prop="img">
                <div v-if="item.img" v-viewer style="cursor: pointer">
                  <img
                    :src="item"
                    v-for="(item, ind) in item.img.split(',')"
                    :key="ind"
                    alt=""
                    style="width: 100px; height: 100px;margin-right: 5px;"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="item.status == 5">
          <el-row>
            <el-col :span="12">
              <el-form-item label="取消时间" prop="createTime">
                <el-input
                  v-model="item.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="item.status == 6">
          <el-row>
            <el-col :span="12">
              <el-form-item label="评价时间" prop="createTime">
                <el-input
                  v-model="item.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="评价描述" prop="des">
                <el-input
                  v-model="item.des"
                  type="textarea" 
                  :rows="5"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>                
        <template v-if="item.status == -1">
          <el-row>
            <el-col :span="12">
              <el-form-item label="拒绝时间" prop="createTime">
                <el-input
                  v-model="item.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="拒绝描述" prop="des">
                <el-input
                  v-model="item.des"
                  type="textarea" 
                  :rows="5"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="拒绝图片" prop="img">
                <div v-if="item.img" v-viewer style="cursor: pointer">
                  <img
                    :src="item"
                    v-for="(item, ind) in item.img.split(',')"
                    :key="ind"
                    alt=""
                    style="width: 100px; height: 100px;margin-right: 5px;"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    addData: Object,
    orderInfos: Object,
  },
  data() {
    return {};
  },
  mounted() {
    console.log(this.addData)
  },
};
</script>

<style>
</style>